import React from 'react';
import { Box } from '@mui/material';

interface Props {
  color?: string;
  height?: number;
  opacity?: string;
  sx?: object;
  width?: number;
}

const Dots2x11Graphic = ({
  color = '#4d88b6',
  height = 300,
  opacity = '.23',
  sx,
  width = 65,
}: Props) => (
  <Box sx={sx}>
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34 250"
      width={width}
      height={height}
    >
      <g id="Group_5451" opacity={opacity}>
        <circle id="Ellipse_48" fill={color} cx="5" cy="5" r="5" />
        <circle id="Ellipse_48-2" fill={color} cx="29" cy="5" r="5" />
        <circle id="Ellipse_48-3" fill={color} cx="5" cy="29" r="5" />
        <circle id="Ellipse_48-4" fill={color} cx="29" cy="29" r="5" />
        <circle id="Ellipse_48-5" fill={color} cx="5" cy="53" r="5" />
        <circle id="Ellipse_48-6" fill={color} cx="29" cy="53" r="5" />
        <circle id="Ellipse_48-7" fill={color} cx="5" cy="77" r="5" />
        <circle id="Ellipse_48-8" fill={color} cx="29" cy="77" r="5" />
        <circle id="Ellipse_48-9" fill={color} cx="5" cy="101" r="5" />
        <circle id="Ellipse_48-10" fill={color} cx="29" cy="101" r="5" />
        <circle id="Ellipse_48-11" fill={color} cx="5" cy="125" r="5" />
        <circle id="Ellipse_48-12" fill={color} cx="29" cy="125" r="5" />
        <circle id="Ellipse_48-13" fill={color} cx="5" cy="149" r="5" />
        <circle id="Ellipse_48-14" fill={color} cx="29" cy="149" r="5" />
        <circle id="Ellipse_48-15" fill={color} cx="5" cy="173" r="5" />
        <circle id="Ellipse_48-16" fill={color} cx="29" cy="173" r="5" />
        <circle id="Ellipse_48-17" fill={color} cx="5" cy="197" r="5" />
        <circle id="Ellipse_48-18" fill={color} cx="29" cy="197" r="5" />
        <circle id="Ellipse_48-19" fill={color} cx="5" cy="221" r="5" />
        <circle id="Ellipse_48-20" fill={color} cx="29" cy="221" r="5" />
        <circle id="Ellipse_48-21" fill={color} cx="5" cy="245" r="5" />
        <circle id="Ellipse_48-22" fill={color} cx="29" cy="245" r="5" />
      </g>
    </svg>
  </Box>
);

export default Dots2x11Graphic;
